import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const TRUSTLY: PaymentMethod = {
    id: PAYMENT_METHOD_ID.Trustly,
    name: 'trustly',
    displayName: 'Trustly'
};
